import styles from 'styles/add/FlexItem.module.css'

const FlexItem = ({ children, shrink, nopadding, full, half, nolabel }) => (
    <div
        className={styles.item}
        full={mark(full)}
        half={mark(half)}
        nolabel={mark(nolabel)}
        style={{
            background: 'white',
            flex: shrink
                ? '0 1 auto'
                : '1 1 auto',
            padding: nopadding
                ? 0
                : 20
        }}>

        { children }
    </div>
)

function mark (param) {
    return param ? 'true' : undefined
}

export default FlexItem